/**
 * Carousel Component
 * @module patterns/components/banners/asset-hero-banner
 */

import { type App } from '~/app';

import JsController from '../js-controller';

export default (app: App) => {

    const controller = new JsController(app, 'Map with Supporting Content');
    controller.addMountFunction(() => {
        mountComponent(controller);
    })

    return controller.init();
}

interface Document {
    exitFullscreen: () => void;
    mozCancelFullScreen: () => void;
    webkitCancelFullScreen: () => void;
    msCancelFullScreen: () => void;
}

interface Map {
    requestFullscreen: () => void;
    webkitRequestFullScreen: () => void;
    mozRequestFullScreen: () => void;
    msRequestFullscreen: () => void;
}
export function mountComponent( controller: JsController ) {
    const mapWithSupportingContents = document.querySelectorAll('.map-with-supporting-content')
    for (const mapWithSupportingContent of mapWithSupportingContents) { 
        const currentDay = getCurrentDay(mapWithSupportingContent)
        const timeRangeElements = mapWithSupportingContent.querySelectorAll('.opening-time-range')
        for (const [index,timeRange] of timeRangeElements.entries()) {
            if (currentDay && index === currentDay - 1 ) {
                const previousDayRange = currentDay == 0 ? null: timeRangeElements[index-1]
                toggleOpenStatus(timeRange,previousDayRange)
            }
        }

        // Enable fullscreen ability  
        const map = mapWithSupportingContent.querySelector<HTMLElement>('.map-container')
        const expandButton = mapWithSupportingContent.querySelector<HTMLElement>('.expand-map-button')
        const sideContent = mapWithSupportingContent.querySelector<HTMLElement>('.supporting-content')
        const centreDirectory = mapWithSupportingContent.querySelector<HTMLElement>('.centre-directory')
        const esriMap = mapWithSupportingContent.querySelector<HTMLElement>('.esrimap')

        if ((expandButton && map && sideContent && centreDirectory && esriMap) ?? (expandButton && map && sideContent )) {
            const blockHeight = sideContent.offsetHeight

            controller.addListener(expandButton, "click", ()=>{
                if(document.fullscreenElement){ 
                    (document as unknown as Document).exitFullscreen();  
                    (document as unknown as Document).webkitCancelFullScreen();
                    (document as unknown as Document).mozCancelFullScreen();
                    (document as unknown as Document).msCancelFullScreen();
                    map.style.height = `${blockHeight}px`
                    if (centreDirectory) {
                        centreDirectory.style.width = `100%`
                    }
                } else { 
                    ( map as unknown as Map).requestFullscreen();
                    ( map as unknown as Map).webkitRequestFullScreen();
                    ( map as unknown as Map).mozRequestFullScreen();
                    ( map as unknown as Map).msRequestFullscreen();
                    if (centreDirectory && esriMap) {
                        centreDirectory.style.width = `100vw`
                        esriMap.style.marginLeft = '0'
                    }
                } 
            });

            controller.addListener(document, "fullscreenchange", ()=>{
                if (!document.fullscreenElement) {
                    map.style.height = `${blockHeight}px`
                    map.classList.add('!max-h-132', 'md:!h-full')
                    if (centreDirectory) {
                        centreDirectory.style.width = `100%`
                    }
                } 
            });
        }
    }
    
}

const getCurrentDay = (element: Element) =>{
    const openingHoursArray = element.querySelectorAll<HTMLElement>('.opening-hours-day');
    if(openingHoursArray){
        const currentDay = new Date().getDay()
        for (const [index, openingHours] of openingHoursArray.entries()) {
            if (index === currentDay - 1) {
                openingHours.parentElement?.classList.add('text-primary-accent-text','font-medium')
                return currentDay
            }            
        }
    }
}

const toggleOpenStatus = (element: Element, previousElement: Element | null)=>{
    const timeRange = element.textContent
    const previousTimeRange = previousElement?.textContent
    
    if (timeRange) {
        const openTime = timeRange.split(" - ")[0].toLowerCase()
        const closeTime = timeRange.split(" - ")[1].toLowerCase()
        let previousCloseTime = null
        if (previousTimeRange) {
            previousCloseTime = previousTimeRange.split(" - ")[1].toLowerCase()
        }
        
        let openTimeHour = 0
        let closeTimeHour = 0
        let previousCloseMins = null

        // Checking the previous day as well to do if shop opens after midnight for currently open
        if(previousCloseTime && previousCloseTime?.includes('am')){
            const previousCloseHours = Number.parseInt(previousCloseTime.split(':')[0]) === 12 ? 0 : Number.parseInt(previousCloseTime.split(':')[0])
            previousCloseMins= previousCloseHours * 60 +  Number.parseInt(previousCloseTime.split(':')[1]);
        }

        if (openTime.includes('am')) {
            openTimeHour = Number.parseInt(openTime.split(':')[0]) === 12 ? 0 : Number.parseInt(openTime.split(':')[0]);
        }else{
            openTimeHour = Number.parseInt(openTime.split(':')[0]) === 12 ? 12 : 12 + Number.parseInt(openTime.split(':')[0])
        }

        const openTimeMin = openTime.split(':')[1].slice(0, -2); 
        
        if (closeTime.includes('am')) {
            closeTimeHour = Number.parseInt(closeTime.split(':')[0]) === 12 ? 24 : 24 + Number.parseInt(closeTime.split(':')[0]);
        }else{
            closeTimeHour = Number.parseInt(closeTime.split(':')[0]) === 12 ? 12 : 12 + Number.parseInt(closeTime.split(':')[0])
        }
        
        const closeTimeMin = closeTime.split(':')[1].slice(0, -2); 

        // Convert hours and minutes into minutes
        const openingTime = openTimeHour * 60 + Number.parseInt(openTimeMin);
        const closingTime = closeTimeHour * 60 + Number.parseInt(closeTimeMin);
        // Get Datalocation 
        const openingHoursContainer = document.querySelector<HTMLElement>('.opening-hours-container ')

        const storeTimezone = openingHoursContainer?.getAttribute('data-timezone')
        const date = new Date(); 
        const storeLocalDate = new Date(date.toLocaleString('en-US', {timeZone: storeTimezone!}))

        const currentTime = storeLocalDate.getHours() * 60 + storeLocalDate.getMinutes();
        
        // Check if current time is not within time range
        const openText = document.querySelector('.currently-open-text')
        const closedText = document.querySelector('.currently-closed-text')

        if (openText && closedText) {
            const isOutsideOpeningHours = currentTime < openingTime || currentTime > closingTime;
            const isAfterPreviousClose = previousCloseMins && currentTime > previousCloseMins ? true : false;
            
            if (isOutsideOpeningHours && isAfterPreviousClose) {
                openText.classList.add('hidden');
                closedText.classList.remove('hidden');
            } else if (!previousCloseMins && isOutsideOpeningHours) {
                openText.classList.add('hidden');
                closedText.classList.remove('hidden');
            }
        }
    }
}
